// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1FnPQ","footer":"ChangeClinic_footer__3cfZr"};